import { type TranslationTree } from '@/i18n/types';

export const messages = {
  badRequest: 'Verifique os dados informados',
  unauthorized: 'Sua sessão expirou. Faça login novamente',
  forbidden: 'Você não tem permissão para realizar esta ação',
  notFound: 'Não encontramos o recurso solicitado',
  serverError: 'Ocorreu um erro no servidor. Tente novamente',
  generic: 'Não foi possível concluir a ação. Tente novamente',
  timeout: 'A requisição demorou demais. Tente novamente',
  offline: 'Não foi possível conectar. Verifique sua internet',
} satisfies TranslationTree;
